export enum PurchaseProviderType {
    BXCHECKOUT = "BXCHECKOUT",
    MOONPAY = "MOONPAY",
    TRANSAK = "TRANSAK"
}